/* ============================================================
   RagHouse Boutique — AJAX cart drawer.
   Add (quick-add + PDP form), change qty, remove. Re-renders the
   drawer via the Section Rendering API so prices stay server-formatted.
   ============================================================ */
(function () {
  'use strict';

  var SECTION = 'rh-cart-drawer';

  function drawer() {
    return document.querySelector('[data-rh-drawer]');
  }
  function overlay() {
    return document.querySelector('[data-rh-overlay]');
  }
  function contents() {
    return document.querySelector('[data-rh-cart-contents]');
  }

  function openCart() {
    var d = drawer(),
      o = overlay();
    if (d) {
      d.classList.add('rh-open');
      d.setAttribute('aria-hidden', 'false');
    }
    if (o) o.classList.add('rh-open');
  }
  function closeCart() {
    var d = drawer(),
      o = overlay();
    if (d) {
      d.classList.remove('rh-open');
      d.setAttribute('aria-hidden', 'true');
    }
    if (o) o.classList.remove('rh-open');
  }

  function syncCount() {
    var c = contents();
    if (!c) return;
    var count = parseInt(c.getAttribute('data-rh-count'), 10) || 0;
    document.querySelectorAll('[data-rh-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function swapSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-rh-cart-contents]');
    var live = contents();
    if (fresh && live) {
      live.innerHTML = fresh.innerHTML;
      live.setAttribute('data-rh-count', fresh.getAttribute('data-rh-count') || '0');
    }
    syncCount();
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function addVariant(id, qty) {
    return postJSON('/cart/add.js', {
      items: [{ id: id, quantity: qty || 1 }],
      sections: SECTION,
      sections_url: window.location.pathname,
    }).then(function (res) {
      if (res.status) {
        window.rhToast && window.rhToast(res.description || 'Could not add to bag');
        return;
      }
      if (res.sections && res.sections[SECTION]) swapSection(res.sections[SECTION]);
      openCart();
      window.rhToast && window.rhToast('Added to bag');
    });
  }

  function addVariants(items) {
    if (!items || !items.length) return Promise.resolve();
    return postJSON('/cart/add.js', {
      items: items,
      sections: SECTION,
      sections_url: window.location.pathname,
    }).then(function (res) {
      if (res.status) {
        window.rhToast && window.rhToast(res.description || 'Could not add to bag');
        return;
      }
      if (res.sections && res.sections[SECTION]) swapSection(res.sections[SECTION]);
      openCart();
    });
  }

  function changeLine(key, qty) {
    return postJSON('/cart/change.js', {
      id: key,
      quantity: qty,
      sections: SECTION,
      sections_url: window.location.pathname,
    }).then(function (res) {
      if (res.sections && res.sections[SECTION]) swapSection(res.sections[SECTION]);
    });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    // open from header bag
    var toggle = e.target.closest('[data-rh-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      openCart();
      return;
    }

    // close
    if (e.target.closest('[data-rh-cart-close]') || e.target.closest('[data-rh-overlay]')) {
      closeCart();
      return;
    }

    // LDP: add a single piece from its row (uses the row's chosen variant)
    var lp = e.target.closest('[data-rh-lpiece-add]');
    if (lp) {
      e.preventDefault();
      var row = lp.closest('.rh-lpiece');
      var sel = row && row.querySelector('[data-rh-lpiece-select]');
      if (sel && sel.value) addVariant(sel.value, 1);
      return;
    }

    // LDP: add the whole look (every piece's chosen, available variant in one call)
    var la = e.target.closest('[data-rh-look-add]');
    if (la) {
      e.preventDefault();
      var scope = la.closest('[data-rh-ldp]') || document;
      var selects = scope.querySelectorAll('[data-rh-look-pieces] [data-rh-lpiece-select]');
      var items = [];
      selects.forEach(function (s) {
        var opt = s.options[s.selectedIndex];
        if (s.value && !(opt && opt.disabled)) items.push({ id: s.value, quantity: 1 });
      });
      if (!items.length) {
        window.rhToast && window.rhToast('These pieces are sold out');
        return;
      }
      addVariants(items).then(function () {
        window.rhToast && window.rhToast('Added the look to your bag');
      });
      return;
    }

    // quick add from card (single-variant adds; multi-variant goes to PDP)
    var quick = e.target.closest('[data-rh-quick]');
    if (quick) {
      e.preventDefault();
      var variants = parseInt(quick.getAttribute('data-rh-variants'), 10) || 1;
      if (variants > 1) {
        window.location.href = quick.getAttribute('data-rh-quick-url');
        return;
      }
      addVariant(quick.getAttribute('data-rh-quick'), 1);
      return;
    }

    // line qty / remove
    var line = e.target.closest('[data-rh-line-qty]');
    if (line) {
      e.preventDefault();
      changeLine(line.getAttribute('data-rh-line-key'), parseInt(line.getAttribute('data-rh-line-qty'), 10));
      return;
    }
  });

  // PDP add-to-bag form
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-rh-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    addVariant(id, qty);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });
  document.addEventListener('DOMContentLoaded', syncCount);
})();
